export default __webpack_public_path__ + "static/media/ip.1f886a18.svg";